<template>
  <group 
    key-prefix="box"
    :config="{...config, draggable}"
    @mouse:over="$emit('mouse:over')"
    @mouse:out="$emit('mouse:out')"
    @mouse:down="$emit('mouse:down')"
    @mouse:up="$emit('mouse:up')"
  >
    <basic-box 
      :key="`shape-box-${name}`"
      :config="boxConfig"
    />
    <template v-if="!hideLabel">
      <slot>
        <Label 
          v-bind="labelBackgroundProps"
          :config="labelConfig"
          :scale="labelScale"
          :background-color="labelBackgroundColor"
        />
      </slot>
    </template>
  </group>
</template>

<script>
import withLabel from './mixins/withLabel'
import basicShape from './mixins/basicShape'
import Group from './Group'
export default {
  name: 'DrawBox',
  components: {Group},
  mixins: [withLabel, basicShape],
  props: {
    cornerRadius: {
      validator (value) {return !isNaN(value)},
      default: 0
    }
  },
  data () {
    return {}
  },
  computed: {
    boxConfig () {
      return {
        ...this.shapeConfig,
        cornerRadius: parseFloat(this.cornerRadius)
      }
    }
  }
}
</script>